import { useFlag } from '@alchemer/unleash';
import { useIsAdvanced, useIsCreator } from '@/api/queries/useSdkTokenQuery';
import { FEATURE_FLAGS } from '@/config/features';
import { PAGE_IDS } from '@/constants/pages';
import { chatterMillRoutes, thoughtSpotRoutes } from '@/customizations/navigationItems';
import NavigationItem from './NavigationItem/NavigationItem';
import SparkNavigationItem from './SparkNavigationItem/SparkNavigationItem';
import ThoughtSpotNavigationItem from './ThoughtspotNavigationItem/ThoughtspotNavigationItem';

export default function NavigationItems() {
  const isCreator = useIsCreator(); // Get from React Query
  const isAdvanced = useIsAdvanced(); // Get from React Query
  const isSparkEnabled = useFlag(FEATURE_FLAGS.SPARK);
  const showSpark = isAdvanced && isSparkEnabled;
  const filteredTSNavItems = thoughtSpotRoutes.filter((item) => {
    if (item.pageId === PAGE_IDS.DataSource && !isCreator) {
      return false;
    }

    if (item.pageId === PAGE_IDS.AIHighlights && !isAdvanced) {
      return false;
    }

    return true;
  });
  return (
    <div className="text-accent-foreground flex bg-white text-sm">
      {showSpark && <SparkNavigationItem />}
      {filteredTSNavItems.map((item) => (
        <ThoughtSpotNavigationItem
          key={item.pageId}
          label={item.label}
          link="/dashboard/$page"
          params={{ page: item.pageId }}
          subnav={item.subnav}
          preload={item.preload}
        />
      ))}
      {chatterMillRoutes.map((item) => (
        <NavigationItem
          key={item.pageId}
          label={item.label}
          link={item.pageId}
          subnav={item.subnav}
        />
      ))}
    </div>
  );
}
